<template>
  <v-app-bar
    app
    :dark="mobile"
    elevate-on-scroll
    :class="{
      primary: mobile,
      'app-toolbar': true,
      'border-bottom': flat && !mobile
    }"
  >
    <v-app-bar-nav-icon @click.stop="clickMenu"></v-app-bar-nav-icon>
    <v-toolbar-title>{{ title }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-progress-linear
      indeterminate
      absolute
      top
      height="5"
      class="ma-0"
      color="grey"
      v-if="loading"
    />
    <refresh-button
      v-if="$store.state.reload.length > 0"
      @click="clickReload"
    />
    <v-menu offset-y>
      <template #activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-subheader> {{ user.name }} </v-subheader>
        <v-list-item :key="1" @click="logout">
          <v-list-item-title>Выход</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <template v-if="tabs" #extension>
      <v-tabs background-color="transparent" slider-color="accent" show-arrows>
        <v-tab
          v-for="(tab, i) in tabs"
          :key="i"
          :to="{ name: tab.name }"
          replace
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs>
    </template>
  </v-app-bar>
</template>
<script>
export default {
  name: "AppToolbar",
  props: ["flat"],
  data() {
    return {
      offsetTop: 0
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
    clickMenu() {
      this.$emit("menu", true);
    },
    clickReload() {
      this.$store.state.reload.forEach(item => item());
    },
    getSiblings(routes) {
      routes = routes || this.$router.options.routes;
      if (routes.filter(item => item.name === this.$route.name).length > 0) {
        return routes;
      }
      for (const item of routes.filter(item => item.children)) {
        const siblings = this.getSiblings(item.children);
        if (siblings && siblings.length) {
          return siblings;
        }
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    title() {
      return this.$store.state.title;
    },
    tabs() {
      if (!this.$route.meta.tab) {
        return false;
      }
      const siblings = this.getSiblings();
      return (
        siblings &&
        siblings
          .filter(item => item.meta.tab && this.user.hasRouteAccess(item))
          .map(item => {
            return {
              title: item.meta.tab,
              name: item.name,
              active: item.name === this.$route.name
            };
          })
      );
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    loading() {
      return this.$store.state.loading;
    }
  }
};
</script>
<style scoped>
.app-toolbar {
  background: #f5f5f5;
}
.border-bottom {
  border-bottom: 1px solid #ddd;
}
</style>
